@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-group-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.groupContext"
                [group]="_context.groupContext.item"
                (groupUpdated)="onGroupUpdated($event)"
                (canceled)="onCanceled($event)"></app-group-form>
        </mat-tab>
        @if (!!_context.groupContext.item.id) {
            <mat-tab label="Groupes enfants">
                <app-group-children-form [readOnly]="true" [context]="_context.groupContext" (groupChildrenUpdated)="onGroupUpdated($event)"></app-group-children-form>
            </mat-tab>
            <mat-tab label="Utilisateurs enfants">
                <app-user-children-form [readOnly]="true" [context]="_context.groupContext" (groupChildrenUpdated)="onGroupUpdated($event)"></app-user-children-form>
            </mat-tab>
            <!-- <mat-tab label="Accessibilité bannettes">
                <app-group-accessibility
                    [group]="_context.groupContext.item"
                    [disabled]="_context.formMode === FormMode.Reading"
                    (accessibilitiesUpdated)="onAccessibilitiesUpdated($event)"></app-group-accessibility>
            </mat-tab> -->
            <mat-tab label="Accessibilité vues">
                <app-group-views-accessibility
                    [group]="_context.groupContext.item"
                    [disabled]="_context.formMode === FormMode.Reading"
                    (viewsAccessibilitiesUpdated)="onViewsAccessibilitiesUpdated($event)"></app-group-views-accessibility>
            </mat-tab>
        }
        @if (!!_context.paramsContext.paramsValues) {
            <mat-tab label="Paramètres">
                <app-parameters-values-form
                    [disabled]="_context.formMode === FormMode.Reading"
                    [context]="_context.paramsContext"
                    [paramsValues]="_context.paramsContext.paramsValues"
                    [hierarchyValues]="_context.paramsContext.groupParentParamsValues"
                    (paramsValuesUpdated)="onParamsValuesUpdated($event)"
                    (paramsExported)="onParamsExported()"
                    (canceled)="onCanceled($event)"></app-parameters-values-form>
            </mat-tab>
        }
    </mat-tab-group>
}
